import { store } from '@/store'
import { Base } from '@/class'

class SpiritForm extends Base {
  private stamina_: number
  private block_: number
  private defenses_: IDefenseData
  private weapons_: string
  private speed_: number
  private traits_: string[]
  private range_modifier_: string

  public constructor(name) {
    super(name)
  }

  // ==========================================================
  // GETTERS
  // ==========================================================
  public get Speed() {
    return this.speed_
  }

  // ==========================================================
  // UTILITY
  // ==========================================================

  public get HasDefenses() {
    return this.defenses_
  }
  public get DefensesHeader() {
    var header = ''
    return '**Defenses:** ' + header
  }
  public get StaminaHeader() {
    return '**Stamina:** ' + this.stamina_
  }
  public get BlockHeader() {
    return '**Guard:** ' + this.block_
  }
  public get SpeedHeader() {
    return '**Move:** ' + this.speed_
  }
  public get Stamina() {
    return this.stamina_
  }
  public get Weapons() {
    return this.weapons_
  }
  public get WeaponsHeader() {
    return '**Weapons:** ' + this.weapons_
  }
  public get RangeHeader() {
    return '**Summon Range:** ' + this.range_modifier_
  }
  public get HasTraits() {
    return this.traits_.length > 0
  }
  public get Traits() {
    return this.traits_
  }
  public get TraitsHeader() {
    return '**Traits:** \n* _' + this.traits_.join('_\n* _') + '_'
  }

  // ==========================================================
  // SERIALIZATION
  // ==========================================================
  public static Deserialize(data: ISpiritFormData): SpiritForm {
    const c = new SpiritForm(data.name)
    c.setSpiritFormData(data)
    return c
  }

  private setSpiritFormData(data: ISpiritFormData): void {
    this.setBaseData(data)
    this.stamina_ = data.stamina
    this.block_ = data.guard
    this.defenses_ = data.defenses || null
    this.weapons_ = data.weapons || ''
    this.speed_ = data.speed || 0
    this.traits_ = data.traits || []
    this.range_modifier_ = data.range_modifier || ''
  }
}
export default SpiritForm
